<script>
	import { onMount } from 'svelte'
  	import { gsap, ScrollTrigger, ScrollToPlugin } from 'gsap/all'
  	gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

	const tl = gsap.timeline({
		scrollTrigger: {
			id: 'logo',
			// markers: true,
			scrub: true,
			start: 'top top',
			end: '200px top',
		}
	})

	// check if body have home class and store to isHome variable vanilla js
	const isHome = document.body.classList.contains('home')

	// listen .hamburger has class is-active
	const hamburger = document.querySelector('.hamburger')
	hamburger.addEventListener('click', () => {
		if (isHome) {
			// check if has class is-active
			if (hamburger.classList.contains('is-active')) {
				// enable timeline
				tl.scrollTrigger.enable()
				tl.scrollTrigger.update()
			} else {
				tl.scrollTrigger.disable()
				tl.scrollTrigger.animation.progress(1)
			}
		}
	})


	onMount(() => {
		if (isHome) {

			tl.fromTo('.logo-svg .inner-text', {
				opacity: 1,
			}, {
				opacity: 0,
			}, 0)
			
			ScrollTrigger.matchMedia({
				"(max-width: 991px)": () => {
					tl.fromTo('.logo-svg', {
						width: '72vw',
						margin: '20vw 14vw',
						left: '0vw',
					}, {
						width: 90,
						margin: 0,
						left: 'auto',
					}, 0)
				},
				"(min-width: 991px)": () => {
					tl.fromTo('.logo-svg', {
						width: '72vw',
						margin: '12vw 14vw',
						left: '0vw',
					}, {
						width: 90,
						margin: '-10px 0 0',
						left: 'auto',
					}, 0)
				}
			})
		}
	})

</script>

<div class="logo">
	<a href="/">
		<div class="logo-inner">
			<svg version="1.1" class="logo-svg" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 558 210" style="enable-background:new 0 0 558 210" xml:space="preserve"><style>.st0{fill:#fff}</style><path class="st0 inner-text" d="m199.2 136.7-11.4-6.6v13.2l11.4-6.6zM187.8 79h9v-2.7H191V66.1h-3.2V79zM198 68.5h2.9v-2.4H198v2.4zm0 10.5h2.9v-9.2H198V79zm10 .3c2.4 0 3.9-1.8 3.9-4.9 0-2.8-1.5-4.9-3.9-4.9-1.3 0-2.1.5-2.6 1.3h-.1v-4.7h-2.9V79h2.8v-1.2c.6 1 1.6 1.5 2.8 1.5zm-.8-2.4c-1.2 0-2-1-2-2.6 0-1.5.6-2.6 1.9-2.6 1.2 0 1.8 1 1.8 2.6 0 1.7-.6 2.6-1.7 2.6zM213 79h2.9v-4.1c0-2 1.2-2.9 3-2.6h.1v-2.6c-.1-.1-.3-.1-.6-.1-1.1 0-1.9.5-2.5 1.6h-.1v-1.4H213V79zm9.3.2c1.4 0 2.2-.5 2.7-1.3.1.5.2.8.3 1h2.8v-.1c-.3-.2-.3-.6-.3-1.3v-4.6c0-1.2-.4-2.1-1.2-2.6-.7-.5-1.6-.8-3-.8-2.8 0-4.1 1.5-4.2 3.2h2.7c.1-.8.6-1.2 1.5-1.2s1.3.4 1.3 1-.6.8-2.3 1c-1.9.3-3.5.9-3.5 2.9.1 1.8 1.4 2.8 3.2 2.8zm1-1.9c-.7 0-1.3-.3-1.3-1s.5-1 1.6-1.2c.6-.1 1.1-.3 1.5-.5v1.1c0 1-.7 1.6-1.8 1.6zm6.1 1.7h2.9v-4.1c0-2 1.2-2.9 3-2.6h.1v-2.6c-.1-.1-.3-.1-.6-.1-1.1 0-1.9.5-2.5 1.6h-.1v-1.4h-2.8V79zm7.3 3h1.9c1.9 0 2.7-.8 3.5-2.9l3.2-9.3h-2.9l-1.2 3.9c-.3.9-.5 2.1-.5 2.1s-.3-1.2-.6-2.1l-1.2-3.9h-3.1l2.7 7.1c.4 1 .6 1.5.6 1.9 0 .6-.3 1-1.2 1h-1V82h-.2zm-48.9 13h2.9v-6.5c0-.5-.1-2.6-.1-2.6s.5 1.9.6 2.4l1.8 6.6h2.6l1.9-6.7c.1-.5.6-2.4.6-2.4s-.1 2.1-.1 2.6v6.5h2.9V82h-4.3l-1.6 5.6c-.2.8-.7 2.9-.7 2.9s-.5-2.1-.7-2.9L192 82h-4.3v13h.1zm19.4.2c1.2 0 2.1-.3 2.9-.8.8-.6 1.4-1.4 1.5-2.2h-2.9c-.3.6-.8.9-1.5.9-1.2 0-1.9-.8-2.1-2h6.6c0-1.9-.5-3.5-1.6-4.5-.8-.7-1.8-1.2-3.2-1.2-2.8 0-4.7 2.1-4.7 4.9.1 2.8 1.9 4.9 5 4.9zm-2-5.8c.2-1.1.8-1.8 1.9-1.8 1 0 1.6.7 1.7 1.8h-3.6zm11.3 5.9c1.2 0 2.2-.6 2.7-1.5V95h2.8V82.1h-2.9v4.7h-.1c-.5-.8-1.3-1.3-2.6-1.3-2.4 0-4 2-4 4.9 0 3 1.7 4.9 4.1 4.9zm.7-2.4c-1.1 0-1.8-1-1.8-2.6 0-1.5.7-2.6 1.9-2.6 1.3 0 1.9 1.1 1.9 2.7 0 1.5-.7 2.5-2 2.5zm6.2-8.4h2.9v-2.4h-2.9v2.4zm0 10.5h2.9v-9.2h-2.9V95zm7.1.2c1.4 0 2.2-.5 2.7-1.3.1.5.2.8.3 1h2.8v-.1c-.3-.2-.3-.6-.3-1.3v-4.6c0-1.2-.4-2.1-1.2-2.6-.7-.5-1.6-.8-3-.8-2.8 0-4.1 1.5-4.2 3.2h2.7c.1-.8.6-1.2 1.5-1.2s1.3.4 1.3 1-.6.8-2.3 1c-1.9.3-3.5.9-3.5 2.9 0 1.8 1.4 2.8 3.2 2.8zm.9-1.9c-.7 0-1.3-.3-1.3-1s.5-1 1.6-1.2c.6-.1 1.1-.3 1.5-.5v1.1c.1 1-.7 1.6-1.8 1.6zm-38.4 18c3 0 5.3-1.5 5.3-4.2 0-2.8-2.2-3.5-4.6-4.1-1.9-.4-2.9-.6-2.9-1.5 0-.7.7-1.2 1.9-1.2s1.9.6 2.1 1.5h3.1c-.1-2.7-2.3-4-5.1-4-2.9 0-5.1 1.2-5.1 4 0 2.7 2.4 3.4 4.6 3.9 1.8.4 2.8.6 2.8 1.7 0 1-1 1.3-2.1 1.3-1.5 0-2.4-.5-2.5-1.8h-3.2c0 2.9 2.3 4.4 5.7 4.4zm11 0c3 0 4.9-2.1 4.9-4.9s-1.9-4.9-4.9-4.9c-3 0-4.9 2.1-4.9 4.9-.1 2.8 1.9 4.9 4.9 4.9zm0-2.1c-1.3 0-1.9-1.1-1.9-2.8 0-1.7.7-2.8 1.9-2.8s2 1.1 2 2.8c-.1 1.7-.8 2.8-2 2.8zm6 1.8h3V98.1h-3V111zm7.6.2c1.3 0 2.1-.5 2.8-1.4h.1v1.1h2.8v-9.2h-3.1v5.1c0 1.1-.6 1.9-1.6 1.9-.9 0-1.4-.6-1.4-1.6v-5.4h-2.9v6c0 2.2 1.1 3.5 3.3 3.5zm10.6-.1c.8 0 1.4-.1 1.6-.1v-2.1h-.6c-.6 0-1-.2-1-.9v-4.3h1.7v-1.8h-1.7V99h-2.9v2.9h-1.2v1.8h1.2v5c0 1.8 1.2 2.4 2.9 2.4zm2.7-10.6h2.9v-2.4h-2.9v2.4zm0 10.5h2.9v-9.2h-2.9v9.2zm8.8.3c3 0 4.9-2.1 4.9-4.9s-1.9-4.9-4.9-4.9-4.9 2.1-4.9 4.9 2 4.9 4.9 4.9zm0-2.1c-1.3 0-1.9-1.1-1.9-2.8 0-1.7.7-2.8 1.9-2.8s2 1.1 2 2.8-.7 2.8-2 2.8zm6 1.8h2.9v-5.1c0-1.1.6-1.9 1.6-1.9s1.4.7 1.4 1.6v5.4h2.9v-6c0-2.1-1.2-3.5-3.2-3.5-1.3 0-2.2.5-2.8 1.5h-.1v-1.3h-2.8v9.3h.1zm14.1.3c2.4 0 4.2-1 4.2-3.1 0-2.4-1.9-2.8-3.5-3-1.2-.2-2.2-.3-2.2-1 0-.6.6-.8 1.3-.8.8 0 1.4.3 1.5 1.1h2.7c-.1-1.8-1.5-3-4.2-3-2.2 0-4 1-4 3 0 2.2 1.7 2.6 3.3 2.9 1.2.2 2.3.3 2.3 1.1 0 .6-.6.9-1.4.9-1 0-1.6-.5-1.7-1.4h-2.8c.1 2 1.8 3.3 4.5 3.3z"/><polygon class="st0" points="242.2,205.2 283.4,205.2 297.9,153.2 227.8,153.2"/><polygon class="st0" points="176.6,55.7 241.2,55.7 226.7,3.6 159.5,3.6 159.5,205.2 204.3,205.2 204.3,153.2 176.6,153.2"/><polygon class="st0" points="50,3.6 0,3.6 0,205.2 140.5,205.2 140.5,162.9 50,162.9"/><polygon class="st0" points="284.8,55.7 350.2,55.7 350.2,153.2 321.5,153.2 321.5,205.2 367.3,205.2 367.3,3.6 299.5,3.6"/><path class="st0" d="M486.5 80.9c-30.2-6.8-45.7-10.2-45.7-24.3 0-11.3 11.6-18.9 29-18.9 18.6 0 30.5 8.7 32.4 24.3H551c-2-42.3-35.8-62-79.6-62-45.1 0-80.2 18.9-80.2 62 0 42.3 36.9 53 72 61.2 27.6 6.8 44 10.2 44 26.2 0 15.2-16.1 21.2-32.4 21.2-24 0-37.2-8.5-39.5-28.8h-50.1c1.1 44.6 36.4 68.2 90.1 68.2 46.5 0 82.7-23.4 82.7-65.7-.1-43.1-33.9-54.7-71.5-63.4z"/></svg>			  
		</div>
	</a>
</div>

<style lang="scss">
	.logo-inner {
		position: relative;
		width: 90px;
		height: 35px;
	}
	.logo-svg
	{
		position: fixed;
		width: 90px;
		@media(min-width: 991px) {
			margin-top: -10px;
		}
		.inner-text {
			opacity: 0;
		}
	}
</style>